import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, use } from "react";
import { Outlet, useLoaderData } from "react-router";
export const CsrfTokenContext = createContext("");
export function CsrfTokenApp() {
    const { csrfToken } = useLoaderData();
    return (_jsx(CsrfTokenContext, { value: csrfToken, children: _jsx(Outlet, {}) }));
}
export function useCsrfToken() {
    return use(CsrfTokenContext);
}
export function CsrfToken() {
    return _jsx("input", { type: "hidden", name: "csrfToken", defaultValue: useCsrfToken() });
}
//# sourceMappingURL=csrf-token.js.map